import { createAsyncStateWithPreloadHook } from '@lib/hooks';
import { INITIATIVES_TABLE_KEYS } from '@sonar-software/sonar-ts-constants';
import { keyPaginationDefaultQueryParams } from '@ui/KeyPagination';
import { PaginatedResource } from '@sonar-software/sonar-ts-types';

import { coreActions, Initiative } from '@sonar-software/sonar-core';

const empty: PaginatedResource<Initiative> = {
	results: [],
	totalCount: 0
};

/**
 * Subscribes to and returns the requested paginated collection of initiatives. Will load related data upon
 * mount if data is not available or forced via `refresh`. Also provides processing flags and a request action.
 * @param refresh Determines if the component should force load the latest data upon mount. Defaults to `false`.
 * @param initialRequest The request to make for initial data load, or force load via `refresh`, instead of the default.
 * @returns A {@link UseInitiativesResult} instance with the related `data`, if the data `isReceived`,
 * if the data `isRequested`, and the `request` action.
 */
export const useInitiatives = createAsyncStateWithPreloadHook({
	defaultRequest: {
		...keyPaginationDefaultQueryParams,
		assignedTos: [],
		sortBy: INITIATIVES_TABLE_KEYS.CREATED_ON,
		sortDirection: 'descending',
		statuses: [],
		title: ''
	},
	loadAction: coreActions.requestGetCoreInitiatives,
	selector: (state) => state.core.initiatives.get,
	useTransform: (result) => ({
		...result,
		data: result.data || empty
	})
});
